var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#3B5998"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M15.3 20.587h2.047v8.123c0 .16.135.29.3.29h3.47c.166 0 .3-.13.3-.29v-8.085h2.353c.153 0 .282-.11.3-.257l.357-2.99a.284.284 0 0 0-.075-.227.306.306 0 0 0-.224-.096h-2.71V15.18c0-.566.316-.852.938-.852h1.772c.166 0 .3-.13.3-.29v-2.746c0-.16-.134-.29-.3-.29h-2.442l-.11-.002c-.425 0-1.897.08-3.06 1.112-1.29 1.143-1.11 2.512-1.067 2.75v2.192H15.3a.296.296 0 0 0-.3.29v2.952c0 .16.134.29.3.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookFull);
export default __webpack_public_path__ + "static/media/facebook-full.29fd1a057515b570a328f9e0a130ecb4.svg";
export { ForwardRef as ReactComponent };